import { Component, Prop, Vue } from 'vue-property-decorator';
import CurrencyFlagDefault from '../currency-flag-default';

@Component({
    components: {
        CurrencyFlagDefault
    }
})
export default class CurrencyFlag extends Vue {
    @Prop()
    code: string;

    @Prop(Boolean)
    selected: boolean;
}
